<!--div [ngClass]="[WidgetColClass]"-->
<div>
  <p-panel [showHeader]="titleKey || title">
    <p-header class="w-100" [ngClass]="{ 'small': estilos && estilos.includes('widget-mini-chart')}">
      <i class="fa fa-pie-chart" aria-hidden="true"></i> {{titleKey|translate}} <div class="float-right m-l-xs"
        *ngIf="legend">
        <button class="btn btn-xs btn-default float-right" (click)="expanded=!expanded"><i class="pi"
            [ngClass]="{'pi-plus': !expanded, 'pi-minus': expanded}"></i></button>
      </div>
    </p-header>
    <!-- <div class="ibox-content"> -->
    <div class="row d-flex justify-content-center">
      <div class="file-manager row main-view-chart {{chartType}}" *ngIf="isOK()">
        <div class="w-100" [ngClass]="expanded || !legend ? estilos+' col-12': estilos +' col-6'">
          <p-chart [type]="chartType" [data]="_chartData" [options]="chartOptions"
            (chartHover)="chartHovered($event)" (onDataSelect)="chartClicked($event)"
            [style]="{'width': '765px', 'height':'382px'}" [height]="chartOptions.height?chartOptions.height:null"
            [width]="chartOptions.width?chartOptions.width:null"></p-chart>
          <!-- <canvas *ngIf="!dataSets" baseChart class="chart" class="flot-overlay" [data]="chartData"
                        [labels]="chartLabels" [colors]="colors" [chartType]="chartType" [options]="chartOptions"
                        (chartHover)="chartHovered($event)" (onDataSelect)="chartClicked($event)" responsive="true">
                    </canvas>
                    <canvas *ngIf="dataSets" baseChart class="chart" class="flot-overlay" [datasets]="dataSets"
                        [labels]="chartLabels" [colors]="colors" [chartType]="chartType" [options]="chartOptions"
                        (chartHover)="chartHovered($event)" (onDataSelect)="chartClicked($event)" responsive="true">
                    </canvas> -->
        </div>
        <div *ngIf="legend" [ngClass]="{'col-12': expanded, 'col-6': !expanded}">
          <div class="hr-line-dashed" *ngIf="expanded" aria-hidden="true"></div>
          <ul class="category-list p-l-0 m-t-lg">
            <!-- <strong>{{title}}</strong> -->
            <li *ngFor="let elemento of chartLabels; let num=index"><a style="padding: 0px;"
                (click)="labelClicked(num)"><i class="fa fa-circle" [style.color]="uiService.backgroundColor[num]"
                  aria-hidden="true">
                </i> <span style="text-transform: lowercase;">{{elemento}} </span></a></li>
          </ul>
          <!-- <div class="hr-line-dashed" aria-hidden="true"></div> -->
        </div>
      </div>
      <div *ngIf="isLoading()">
        <waitLoading [maxView]="false"></waitLoading>
      </div>
      <div class="col-12" *ngIf="isError()">
        <!-- TODO: Comporbar que el servicio no devuelve datos y mostrar la información -->
        <div class="alert alert-info m-b-xs text-ellipsis col-12">
          <span><i class="fas fa-1-5x fa-info-circle m-r-md" aria-hidden="true"></i>
          </span> {{ 'Widget.error' | translate }}
        </div>
      </div>
      <div class="col-12" *ngIf="isEmpty()">
        <!-- TODO: Comporbar que el servicio no devuelve datos y mostrar la información -->
        <div class="alert alert-info m-b-xs text-ellipsis col-12">
          <span>
            <i class="fas fa-1-5x fa-info-circle m-r-md" aria-hidden="true"></i> {{ 'Widget.empty.data' | translate
            }}</span>
        </div>
      </div>
    </div>
    <!-- </div> -->
  </p-panel>
</div>